import { Modal } from "antd";

const ImageViewer = ({ imageUrl, onClose }) => {
  return (
    <Modal
      open={imageUrl}
      footer={null}
      onCancel={() => onClose()}
      centered
      width={600}
    >
      <img src={imageUrl} alt="zoomed" className="w-full h-auto rounded-lg" />
    </Modal>
  );
};
export default ImageViewer;
